import React from 'react';
import _get from 'lodash/get';

import { TableHeading } from 'components/Tables';
import SyncButton from './SyncButton';
import { useSupportedProductAttributes } from 'utils/hooks';
import { useProductsCatalog } from '../../hooks';
import { getCopies } from '../../methods';
import { DOC_LINKS } from '../../stubs';

export default function Header() {
  const { supportsType, supportsCategory } = useSupportedProductAttributes();

  const { entity } = useProductsCatalog();

  const docUrl = _get(DOC_LINKS, entity, '');
  const copies = getCopies(entity, supportsType, supportsCategory);

  return (
    <TableHeading
      title={copies.title}
      helpText={copies.helpText}
      documentationUrl={docUrl}
      titleClassName="text-capitalize"
    >
      <SyncButton />
    </TableHeading>
  );
}
